export enum FeedbackContext {
  AGENT_CALL_END = "agent-call-end",
}
